import { createSlice } from '@reduxjs/toolkit';
import {
	getCompanyList,
	addNewCompany,
	updateCompany,
	deleteCompany,
	getCompany,
} from '../company/thunk';

export const initialState = {
	itemCompanyList: [],
	itemCompanyDetail: null,
	isCompanyLoading: false,
	isCompanySuccess: false,

	companyList: [],
	companyListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const CompanySlice = createSlice({
	name: 'Companies',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getCompany.fulfilled, (state, action) => {
			state.isCompanyLoading = false;
			state.isCompanySuccess = true;
			state.itemCompanyDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getCompany.pending, state => {
			state.isCompanyLoading = true;
			state.isCompanySuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getCompany.rejected, (state, action) => {
			state.isCompanyLoading = false;
			state.isCompanySuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getCompanyList.pending, state => {
			state.isCompanySuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getCompanyList.fulfilled, (state, action) => {
			state.itemCompanyList = action.payload;
			state.companyList = action.payload;
			state.isLoadingList = false;
			state.isCompanySuccess = true;

			let companyListSelect = [];
			action.payload.map(item =>
				companyListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.companyListSelect = companyListSelect;
		});
		builder.addCase(getCompanyList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isCompanySuccess = true;
		});
		builder.addCase(addNewCompany.fulfilled, (state, action) => {
			state.itemCompanyList.push(action.payload);
			state.companyList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewCompany.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewCompany.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateCompany.fulfilled, (state, action) => {
			state.itemCompanyList = state.itemCompanyList.map(company =>
				company.companyname === action.payload.old_company
					? { ...company, ...action.payload.updated_company }
					: company
			);
			state.companyList = state.companyList.map(company =>
				company._id.toString() === action.payload._id.toString()
					? { ...company, ...action.payload }
					: company
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateCompany.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateCompany.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteCompany.fulfilled, (state, action) => {
			state.itemCompanyList = current(state.itemCompanyList).filter(
				item => item._id !== action.payload._id
			);
			state.companyList = current(state.companyList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteCompany.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteCompany.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = CompanySlice.actions;

export default CompanySlice.reducer;
